import styled, { css } from 'styled-components';

const gradient = 'linear-gradient(to right, #10245A 2%, #695EDF 25%, #4477ED 47%, #5737e6 60%)';

// Shared text styles
const textClipStyles = css`
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
`;

export const StyledPlanCard = styled.div<{
  $isHighestPlan: boolean;
  $havingPriceTag: boolean;
  $smDown: boolean;
}>`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 1rem;
  position: relative;
  height: 100%;
  position: relative;
  padding: 1.5rem 1rem 1rem;
  border-radius: ${({ $smDown }) => ($smDown ? 0 : '1rem')};
  background-color: #fff;
  border: 1px solid rgb(222, 222, 222);
  ${({ $havingPriceTag }) => $havingPriceTag && 'border: 1px solid #000;'}
  &:hover {
    ${({ $isHighestPlan }) =>
      $isHighestPlan &&
      'box-shadow: 0px 4px 20px rgba(128, 81, 255, 0.2), 0px 8px 32px rgba(128, 81, 255, 0.16), 0px 12px 32px rgba(128, 81, 255, 0.08);'}
  }

  .plan-tag {
    position: absolute;
    top: -0.75rem;
    left: 0.875rem;
    z-index: 1;

    .Polaris-Badge {
      background: #1a1a2e;
      border-radius: 9999px;
      padding: 2px 12px;
      min-height: auto;
    }
    .Polaris-Badge .Polaris-Text--root {
      color: #fff;
      font-size: 0.6875rem;
      font-weight: 600;
    }
  }

  .plan-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    flex-wrap: wrap;
  }

  .plan-title {
    background: ${({ $isHighestPlan }) => ($isHighestPlan ? gradient : '#303030')};
    ${textClipStyles};
  }

  .plan-des {
    background: ${({ $isHighestPlan }) => ($isHighestPlan ? gradient : '#616161')};
    ${textClipStyles};
  }

  .Polaris-Icon {
    margin: 0;
    height: 1.25rem;
    width: 1.25rem;
  }

  .account-benefit {
    padding-block: 0.1rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.5rem;
    color: var(--p-color-text-secondary);

    &.padding {
      margin-left: -0.25rem;
    }

    .plan-card-item {
      width: fit-content;
      border-top: 1px dashed transparent;
      border-bottom: 1px dashed transparent;
    }

    &.tooltip {
      .plan-card-item {
        &:hover {
          border-bottom: 1px dashed blue;
        }
      }
    }

    &.ai-feature {
      .Polaris-Icon svg {
        fill: #7c3aed;
      }

      .plan-card-item {
        color: #7c3aed;
      }
    }
  }

  .footer-item {
    margin-block: 0.5rem;
    .Polaris-Badge,
    .Polaris-Button {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .Polaris-Badge {
      height: 2rem;
      padding: 0.375rem 1rem;
      .Polaris-Text--root {
        font-size: 0.8125rem;
      }
    }
  }

  .Polaris-Link:focus {
    outline: none;
  }

  .highlight-quota {
    padding: 0.75rem 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    border-radius: 0.75rem;

    border: ${({ $isHighestPlan }) => ($isHighestPlan ? '1px solid #b8aeff' : 'none')};
    background: ${({ $isHighestPlan }) =>
      $isHighestPlan
        ? `linear-gradient(
      to bottom,
      #f2f1ff 9%,
      #ffffff 94%,
      #f6e6ff 100%
    )`
        : '#f7f7f7'};

    &-title {
      background: ${({ $isHighestPlan }) => ($isHighestPlan ? gradient : '#616161')};
      ${textClipStyles};
    }

    ul {
      margin-block: 0;
    }

    li {
      color: var(--p-color-text-secondary);
      margin-block: 0;
      line-height: 1.25rem;
    }

    .highlight-visibility {
      visibility: hidden;
    }
  }

  .plan-price {
    min-height: 2.625rem;
  }
  .progress {
    height: 1rem;
    display: flex;
    align-items: center;
  }
`;
